import React from 'react';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { useLanguage } from '../contexts/LanguageContext'; 
import heroImage from '../assets/image/cherman2.jpeg';

export function Hero() {
  const { t } = useLanguage();

  return (
    <section id="home" className="hero">
  
      <div className="hero__background">
        <ImageWithFallback
         src={heroImage}
          alt="Temple architecture"
        />
        <div className="hero__overlay"></div>
      </div>

      <div className="hero__content">
        <h2 className="hero__title">{t('hero.title')}</h2>
        <p className="hero__subtitle">
          {t('hero.subtitle')}
        </p>
        <button
          onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
          className="hero__cta"
        >
          {t('hero.cta')}
        </button>
      </div>
    </section>
  );
}
